import { object } from "zod/v4";

export const deleteNetSuiteIntegration = {
  name: "deleteNetSuiteIntegration" as const,
  input: object({}),
  output: object({}),
};
